import React, { useMemo, useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap-5';
import TemplateForm from './template_form';
import { createDataExportTemplate } from '../../helpers/prospect_api';
import type {
  DataExportTemplate,
  DataExportTemplateColumnOptions,
  DataExportTemplateForm
} from 'bundles/connect/types';

type Option = {
  value: string;
  label: string;
};

type Props = {
  columnOptions: DataExportTemplateColumnOptions;
  show: boolean;
  onHide: () => void;
  onTemplateAdded: (template: DataExportTemplate) => void;
};

export default function NewTemplateModal({ columnOptions, show, onTemplateAdded, onHide }: Props) {
  const [formData, setFormData] = useState<DataExportTemplateForm>({ name: '' });
  const [selectedColumns, setSelectedColumns] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) {
      setFormData({ name: '' });
      setSelectedColumns([]);
    }
  }, [show]);

  useEffect(() => {
    if (formData.dataExportType !== undefined) {
      setSelectedColumns([]);
    }
  }, [formData.dataExportType]);

  const handleSave = () => {
    setLoading(true);
    const params = {
      ...formData,
      columns: selectedColumns.map(c => c.value)
    };

    createDataExportTemplate(params).then((response) => {
      setLoading(false);
      onHide();
      onTemplateAdded(response.dataExportTemplate);
    });
  };

  const canSubmit = useMemo(() => {
    if (loading) return false;

    return formData.name.length > 2 && selectedColumns.length > 0;
  }, [loading, formData.name, selectedColumns]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>New Data Export Template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TemplateForm
          columnOptions={columnOptions}
          formData={formData}
          selectedColumns={selectedColumns}
          setFormData={setFormData}
          setSelectedColumns={setSelectedColumns}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant="outline-primary" onClick={onHide}>Cancel</Button>
        <Button disabled={!canSubmit} variant="secondary" onClick={handleSave}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
